/** Codes renvoyés par l'API (AccessBlockListener) quand un espace est bloqué. */
export const BLOCK_MESSAGES = {
    AGENT_BLOCKED: 'Votre accès à l\'administration a été désactivé par votre commune.',
    PRO_BLOCKED: 'Votre accès à l\'espace professionnel a été désactivé par votre commune.',
    NO_ACCESS: 'Ce compte n\'a pas accès à l\'administration. Pour utiliser les services de votre commune, utilisez l\'application Ma Commune Live.',
};
const isAgent = (u) => u.roles.includes('ROLE_ADMIN_COMMUNE') || u.roles.includes('ROLE_OPERATOR');
const isPro = (u) => u.roles.includes('ROLE_PRO');
export const canUseAgentSpace = (u) => isAgent(u) && !u.agent_blocked;
export const canUseProSpace = (u) => isPro(u) && !u.pro_blocked;
/** Message à afficher si le compte n'a plus aucun espace utilisable dans l'admin, sinon null. */
export function blockedMessage(u) {
    if (u.roles.includes('ROLE_SUPER_ADMIN') || canUseAgentSpace(u) || canUseProSpace(u))
        return null;
    if (isAgent(u) && u.agent_blocked)
        return BLOCK_MESSAGES.AGENT_BLOCKED;
    if (isPro(u) && u.pro_blocked)
        return BLOCK_MESSAGES.PRO_BLOCKED;
    // Compte d'habitant sans rôle d'agent ni de pro : il n'a rien à faire ici
    // (sans ce cas, il tournait en boucle entre /commune et la garde de rôle).
    return BLOCK_MESSAGES.NO_ACCESS;
}
